<template>
  <table class="table table-bordered table-vertical-center table-hover">
    <thead>
      <tr>
        <th style="width: 5%; text-align: center">STT</th>
        <th style="width: 50%">Tên thương hiệu</th>
        <th style="width: 10%"></th>
      </tr>
    </thead>
    <tbody>
      <BrandItem
        v-for="(item, index) in brands"
        :key="item.id"
        :item="item"
        :parent-edit="parentEdit"
        :current-page="currentPage"
        :items-per-page="itemsPerPage"
        :index="index"
        @update="$emit('update', $event)"
        @delete="$emit('delete', $event)"
        @add="$emit('add', $event)"
        @cancel-add="$emit('cancel-add')"
      />
    </tbody>
  </table>
</template>

<script>
import BrandItem from './BrandItem.vue';

export default {
  name: 'BrandTable',
  components: {
    BrandItem,
  },
  props: {
    brands: {
      type: Array,
      required: true,
    },
    parentEdit: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
  },
  emits: ['update', 'delete', 'add', 'cancel-add'],
};
</script>
